module.exports = __webpack_public_path__ + "static/benef3_jaune-b373767095cdb028270e5dc40de8ebe2.jpg";